import React, { useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Select,
    MenuItem,
    Alert
} from '@mui/material';

const AddChoreModal = ({ open, onClose, onChoreAdded, backendUrl, authTokens, currentRelationship }) => {
    const [choreName, setChoreName] = useState('');
    const [choreType, setChoreType] = useState(0);
    const [weight, setWeight] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async () => {
        if (!choreName.trim()) {
            setError('Chore name is required');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${backendUrl}api/chores/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authTokens.access}`,
                },
                body: JSON.stringify({
                    name: choreName.trim(),
                    chore_type: choreType,
                    weight: weight,
                    relationship_id: currentRelationship?.relationship_id
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to create chore');
            }

            const newChore = await response.json();

            // Call the callback to update the chores list
            onChoreAdded(newChore);

            // Reset form and close modal
            handleClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setChoreName('');
        setChoreType(0);
        setWeight(1);
        setError('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Add New Chore</DialogTitle>
            <DialogContent>
                {error && (
                    <Alert severity="error" sx={{ marginBottom: 2 }}>
                        {error}
                    </Alert>
                )}

                <TextField
                    label="Chore Name"
                    value={choreName}
                    onChange={(e) => setChoreName(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                    inputProps={{ maxLength: 100 }}
                    helperText={`${choreName.length}/100`}
                />

                <FormControl component="fieldset" sx={{ marginTop: 2, marginBottom: 2 }}>
                    <FormLabel>Chore Type</FormLabel>
                    <RadioGroup
                        value={choreType}
                        onChange={(e) => setChoreType(parseInt(e.target.value))}
                    >
                        <FormControlLabel
                            value={0}
                            control={<Radio />}
                            label="Simple (One person completes it)"
                        />
                        <FormControlLabel
                            value={2}
                            control={<Radio />}
                            label="Time-tracked (Track hours for each person)"
                        />
                    </RadioGroup>
                </FormControl>

                <FormControl fullWidth sx={{ marginTop: 2 }}>
                    <FormLabel>Weight</FormLabel>
                    <Select
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                    >
                        {[...Array(10).keys()].map((num) => (
                            <MenuItem key={num + 1} value={num + 1}>
                                {num + 1}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={loading || !choreName.trim()}
                >
                    {loading ? 'Adding...' : 'Add Chore'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddChoreModal;